var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "fee-wrapper" }, [
    _c(
      "li",
      {
        staticClass: "fee-item",
        attrs: { "aria-label": `Subtotal: $${_vm.subtotal}`, tabindex: "0" },
      },
      [
        _c("span", { staticClass: "fee-label" }, [_vm._v("Subtotal")]),
        _vm._v(" "),
        _c("span", { staticClass: "fee-total" }, [
          _vm._v(_vm._s(_vm._f("toCurrency")(_vm.subtotal))),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "li",
      {
        staticClass: "fee-item",
        attrs: {
          "aria-label": `Service Fee: $${_vm.taxService}`,
          tabindex: "0",
        },
      },
      [
        _vm.serviceFee == " 0.00"
          ? _c("span", { staticClass: "fee-label" }, [_vm._v("Tax")])
          : _c("span", { staticClass: "fee-label" }, [
              _vm._v("Tax/Service\n      "),
              _c("i", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content: _vm.taxServiceTooltip,
                      trigger: "hover click focus",
                      container: false,
                    },
                    expression:
                      "{ content: taxServiceTooltip, trigger: 'hover click focus', container: false }",
                  },
                ],
                staticClass: "fas fa-info-circle",
                attrs: {
                  alt:
                    "Service Fee: $" +
                    _vm.serviceFee +
                    " Tax: $" +
                    _vm.taxAmount,
                },
              }),
            ]),
        _vm._v(" "),
        _c("span", { staticClass: "fee-total" }, [
          _vm._v(_vm._s(_vm._f("toCurrency")(_vm.taxService))),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.utensilsApplied
      ? _c(
          "li",
          {
            staticClass: "fee-item",
            attrs: {
              "aria-label": `Utensils Fee: $${_vm.utensilsPrice}`,
              tabindex: "0",
            },
          },
          [
            _c("span", { staticClass: "fee-label" }, [_vm._v("Utensils")]),
            _vm._v(" "),
            _c("span", { staticClass: "fee-total" }, [
              _vm._v(_vm._s(_vm._f("toCurrency")(_vm.utensilsPrice))),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "li",
      {
        staticClass: "fee-item",
        attrs: {
          "aria-label": `Delivery Fee: $${_vm.delivery}`,
          tabindex: "0",
        },
      },
      [
        _c("span", { staticClass: "fee-label" }, [_vm._v("Delivery")]),
        _vm._v(" "),
        _c("span", { staticClass: "fee-total" }, [
          _vm._v(_vm._s(_vm._f("toCurrency")(_vm.delivery))),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.gratuity
      ? _c(
          "li",
          {
            staticClass: "fee-item",
            attrs: {
              "aria-label": `Gratuity: $${_vm.gratuity}`,
              tabindex: "0",
            },
          },
          [
            _c("span", { staticClass: "fee-label" }, [_vm._v("Gratuity")]),
            _vm._v(" "),
            _c("span", { staticClass: "fee-total" }, [
              _vm._v(_vm._s(_vm._f("toCurrency")(_vm.gratuity))),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.custIsPayingMinFee
      ? _c(
          "li",
          {
            staticClass: "fee-item",
            attrs: {
              "aria-label": `Minimum Fee: $${_vm.minFee}`,
              tabindex: "0",
            },
          },
          [
            _c("span", { staticClass: "fee-label" }, [_vm._v("Min. Fee")]),
            _vm._v(" "),
            _c("span", { staticClass: "fee-total" }, [
              _vm._v(_vm._s(_vm._f("toCurrency")(_vm.minFee))),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.couponAdj
      ? _c(
          "li",
          {
            staticClass: "fee-item",
            attrs: {
              "aria-label": `Coupon Adjustment: -$${_vm.couponAdj}`,
              tabindex: "0",
            },
          },
          [
            _c("span", { staticClass: "fee-label" }, [_vm._v("Coupon")]),
            _vm._v(" "),
            _c("span", { staticClass: "fee-total" }, [
              _vm._v(_vm._s(_vm._f("toCurrency")(_vm.couponAdj, true))),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }